import {Component, inject} from '@angular/core';
import {MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {MatTooltip} from '@angular/material/tooltip';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';
import {GeographyService} from '../../../../services/geography.service';
import {ErrorHandlingService} from '../../../../services/error-handling.service';
import {SnackbarService} from '../../../../services/snackbar.service';
import {IRegionTaxRate} from '../../../../interfaces/IRegionTaxRate';
import {RegionTaxRateStatus} from '../../../../enum/RegionTaxRateStatus';

export interface IRegionTaxRateActionsContext {
  onCancelSuccess: () => void;
}

@Component({
  selector: 'app-region-tax-rate-actions',
  standalone: true,
  imports: [
    MatIconButton,
    MatIcon,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    MatTooltip
  ],
  templateUrl: './region-tax-rate-actions.component.html'
})
export class RegionTaxRateActionsComponent implements ICellRendererAngularComp {

  private geographyService = inject(GeographyService);
  private errorHandlingService = inject(ErrorHandlingService);
  private snackbarService = inject(SnackbarService);

  public params!: ICellRendererParams<IRegionTaxRate, any, IRegionTaxRateActionsContext>;
  public isScheduled = false;

  agInit(params: ICellRendererParams<IRegionTaxRate, any, IRegionTaxRateActionsContext>): void {
    this.params = params;
    this.isScheduled = params.data!.Status === RegionTaxRateStatus.Scheduled;
  }

  refresh(params: ICellRendererParams<IRegionTaxRate, any, IRegionTaxRateActionsContext>): boolean {
    return false;
  }

  public cancelScheduledRate(): void {
    const rate = this.params.data!;
    this.geographyService.cancelScheduledTaxRate(rate.RegionId, rate.Id).subscribe({
      next: () => {
        this.snackbarService.openSuccessfulSnackBar('Scheduled rate change cancelled successfully');
        this.params.context?.onCancelSuccess();
      },
      error: (err) => {
        this.errorHandlingService.displayPageLevelErrorMessage(err);
      }
    });
  }
}
